module.exports = __webpack_public_path__ + "img/picture_35.2ebe32c6.png";